import keycloakService from '../keycloak_service';

import { sinatraOrigin } from '../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then((response) => {
  if (!response.ok){
    throw new Error(response?.statusText || 'Unexpected Server Error');
  }
  return response.json();
});

export const deployPipeline = (pipelineName, pipelineID, pipelineVersionId, models, model_configs = []) => {
  const body = JSON.stringify({
    deploy_id: `${pipelineName}`,
    pipeline_id: pipelineID,
    pipeline_version_pk_id: pipelineVersionId,
    models,
    model_configs,
  })

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v1/api/pipelines/deploy', fetchOptions)
}

/**
 * interface UndeployOptions {
 * deployment_id: Number,
 * pipeline_id: Number.
 * }
 */
export const undeployPipeline = (deploymentOrPipelineID) => {
  if (!deploymentOrPipelineID || (!deploymentOrPipelineID.deployment_id && !deploymentOrPipelineID.pipeline_id)) {
    throw new Error('Missing required options for undeployment');
  }

  const body = JSON.stringify(deploymentOrPipelineID.deployment_id ? {
    deployment_id: deploymentOrPipelineID.deployment_id
  } : {
    pipeline_id: deploymentOrPipelineID.pipeline_id
  })

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v1/api/pipelines/undeploy', fetchOptions)
}

export default {
  deployPipeline, undeployPipeline
}
